import { Box, Typography, IconButton } from '@castlery/fortress';
import { ChevronUp, Close } from '@castlery/fortress/Icons';
import type { GiftHeaderProps } from '../types';
import { TagIcon } from './TagIcon';
export const GiftHeader = ({ isChangeGift, isOpen, onToggle, onChangeClose, mobileLayout }: GiftHeaderProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: !isChangeGift ? 'pointer' : 'default',
    }}
    onClick={() => {
      if (!isChangeGift) {
        onToggle?.();
      }
    }}
  >
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      <TagIcon
        text="FREE"
        useMobile={mobileLayout}
        sx={{
          color: 'var(--fortress-palette-brand-warmLinen-500)',
        }}
      />
      <Typography level="caption1">Choose your Gift</Typography>
    </Box>

    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
    >
      <IconButton
        sx={{
          '--Icon-fontSize': 24,
          minWidth: 24,
          minHeight: 24,
          width: 24,
          height: 24,
          '&:hover': {
            '--Icon-color': 'var(--fortress-palette-brand-mono-900)',
          },
          svg: {
            width: 24,
            height: 24,
          },
        }}
        onClick={() => {
          if (isChangeGift) {
            onChangeClose?.();
          }
        }}
      >
        {isChangeGift ? (
          <Close />
        ) : (
          <ChevronUp
            sx={{
              transform: `rotate(${isOpen ? 0 : 180}deg)`,
              transition: 'transform 0.5s ease',
            }}
          />
        )}
      </IconButton>
    </Box>
  </Box>
);
